import { request } from '../utils/request-utils';

import { getQuarantinedCitiesURL } from './urls';

/** @returns {Promise<string[]>} */
export const fetchQuarantinedCitiesList = async () =>
  request(getQuarantinedCitiesURL());
